<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C5M0lB/tc-custom/9781626816695.jpg?1736861365497" alt="This image is the cover for the book Runaway Passion, Silver Creek Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Runaway Passion, Silver Creek Stories
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Texas Rancher’s daughter is on the run and the man sent to bring her home may be her ticket to freedom in this historical western romance.</b><br/><br/><i>Texas, 1879</i>. Emilie Hahn has tried to escape her father’s Texas ranch before. But this time she has a plan. And not even the handsome rancher sent to pursue her will drag her back without a fight. Even as she resists his attempts to return her to her father, her heart can’t deny the intense desire that draws them together.<br/><br/> Creed McCaslin has been hired to rescue Emilie, and he’s not one to leave a job undone. Even when he learns that she’s a runaway—and not the damsel in distress her father has made her out to be—he still pursues the brave and beautiful young woman. But his mission never included falling in love with his quarry. Once Creed catches up to Emilie, will he return her to the ranch, or will they ride off together?<br/><br/><b>“A wonderful adventure and a sensitive romance.” —<i>RT Book Reviews</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivian Vaughan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08654791